// let path = "https://forms-api.vosmos.live";
// if (process.env.NODE_ENV === "development") {
//   path = "http://localhost:4002";
// }
export const method = {
  post: "post",
  put: "put",
  get: "get",
  delete: "delete",
};
// export const basePath = path;
export const apiPath = "/api";
export const apiDashboard = "/app";
export const apiLoginUser = "/auth/login";
export const apiLogutUser = "/auth/logout";
export const apiGetUser = "/auth/user";
export const apiRegisterUser = "/auth/register";
export const apiVenues = "/venues";
export const apiVendors = "/vendors";
export const apiCrm = "/crm";
export const apiLeads = "/crm/leads";
export const apiEstimates = "/crm/estimates";
export const apiUpload = "/upload";
export const apiAttendees = "/attendees";